import moment from "moment"

export const isPlannedPromotion = (startDate: number) =>
  moment().isBefore(startDate)

export const isActivePromotion = (startDate: number, endDate: number) =>
  moment().isBetween(startDate, endDate)

export const isExpiredPromotion = (endDate: number) => moment().isAfter(endDate)
